/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import '../device/device.scss';

/* eslint-disable import/no-unresolved, import/default */

import multicastGroupFieldsetTemplate from './multicast-group-fieldset.tpl.html';


/*@ngInject*/
export default function MulticastGroupDirective($compile, $templateCache, $translate, $window, $timeout, deviceService, toast, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(multicastGroupFieldsetTemplate);
        element.html(template);

        scope.types = types;

        scope.$watch('multicastGroup.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    resetDownlinkForm();
                }
            }
        });

        scope.onMulticastGroupIdCopied = function () {
            toast.showSuccess($translate.instant('multicast-group.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 2) {
                    scope.selectedTab = 0;
                }
            }
        });

        scope.triggerResize = function () {
            $timeout(() => {
                var w = angular.element($window);
                w.triggerHandler('resize');
                $window.dispatchEvent(new Event("resize")); //eslint-disable-line
            }, 100);
        };

        scope.generateDevAddress = function() {
            deviceService.getUniqueDevAddress().then(
                (newDevAddress) => {
                    scope.multicastGroup.devAddress = newDevAddress;
                }
            )
        }

        function resetDownlinkForm() {
            scope.downlink = {};
            scope.downlinkForm.$setPristine();
            scope.downlinkForm.$setUntouched();
            scope.showDownlinkForm = false
        }

        scope.showAddDownlinkForm = function () {
            scope.showDownlinkForm = scope.showDownlinkForm ? !scope.showDownlinkForm : true;
        };

        scope.initDownlinkForm = function (form) {
            scope.downlinkForm = form
        }

        scope.addDownlinkToQueue = function () {
            deviceService.postDownlinkToQueue(scope.multicastGroup.id.id, scope.downlink).then(function success() {
                toast.showSuccess($translate.instant('multicast-group.downlinks.add-downlink-to-queue-success'));
                resetDownlinkForm();
            });
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            multicastGroup: '=',
            isEdit: '=',
            theForm: '=',
            selectedTab: "="
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/multicast-group/multicast-group.directive.js